module.exports = __webpack_public_path__ + "media/proximanova-light.e71864b9.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/proximanova-light.woff
// module id = 102
// module chunks = 9